<template><div><h2 id="uppercase" tabindex="-1" class="d-docsite--header-2">Uppercase <a class="header-anchor d-link d-docsite--link d-link" href="#uppercase" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tt-uppercase</code> to uppercase an element's text.</p>
<code-example source-code='&lt;p class=&quot;d-tt-uppercase&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-tt-uppercase">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="lowercase" tabindex="-1" class="d-docsite--header-2">Lowercase <a class="header-anchor d-link d-docsite--link d-link" href="#lowercase" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tt-lowercase</code> to lowercase an element's text.</p>
<code-example source-code='&lt;p class=&quot;d-tt-lowercase&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-tt-lowercase">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="capitalize" tabindex="-1" class="d-docsite--header-2">Capitalize <a class="header-anchor d-link d-docsite--link d-link" href="#capitalize" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-tt-capitalize</code> to capitalize an element's text.</p>
<code-example source-code='&lt;p class=&quot;d-tt-capitalize&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-tt-capitalize">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in transform">
        <th scope="row" class="d-code--sm d-docsite-code">.d-tt-{{ i }}</th>
        <td class="d-code--sm">text-transform: {{ i }} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { transform } from '@data/type.json';
</script>